import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=66dfd1b7&scoped=true"
import script from "./ConfirmAccount.vue?vue&type=script&lang=ts"
export * from "./ConfirmAccount.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&id=66dfd1b7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0._83348a1cf597b13f55aa1c5cb85cf58d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfd1b7",
  null
  
)

export default component.exports